<template>
  <div class="tab-filled" :class="variant">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabFilled",
  components: {},
  props: {
    active: { type: String, default: "" },
    show: { type: Boolean, default: false },
    variant: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
</style>
